import React from 'react';

import OTPForm from '../components/OTPForm';

const OTPPage = () => {
  return <OTPForm />;
};

export default OTPPage;
